import { GETDEPARTMENTDETAILS_FAIL, GETDEPARTMENTDETAILS_SUCCESS } from '../actionTypes';

const initialState = {
	user: []
};

const getDepartmentDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GETDEPARTMENTDETAILS_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case GETDEPARTMENTDETAILS_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default getDepartmentDetailsReducer;
